import { Box, u, IconButton, SingleMediaIcon, DoubleMediaIcon, FullMediaIcon } from '@ui';

import * as css from './PlaybackScreen.css';

export const mediaVariants = {
    SINGLE: 'SINGLE',
    DOUBLE: 'DOUBLE',
    FULL: 'FULL',
} as const;

export type MediaVariant = keyof typeof mediaVariants;

type MediaVariantControlProps = {
    variant: MediaVariant;
    setVariant: (variant: MediaVariant) => void;
};

export const MediaVariantControl = ({ variant, setVariant }: MediaVariantControlProps) => {
    return (
        <Box display="flex" gap={u(0.5)} className={css.buttonGroup}>
            <IconButton
                className={css.button[variant === mediaVariants.SINGLE ? 'active' : 'default']}
                onClick={() => setVariant(mediaVariants.SINGLE)}
            >
                <SingleMediaIcon size={18} />
            </IconButton>
            <IconButton
                className={css.button[variant === mediaVariants.DOUBLE ? 'active' : 'default']}
                onClick={() => setVariant(mediaVariants.DOUBLE)}
            >
                <DoubleMediaIcon size={18} />
            </IconButton>
            <IconButton
                className={css.button[variant === mediaVariants.FULL ? 'active' : 'default']}
                onClick={() => setVariant(mediaVariants.FULL)}
            >
                <FullMediaIcon size={18} />
            </IconButton>
        </Box>
    );
};
